import React, {Component} from 'react';
import Banner from "./../common/banner/banner";
import Schedule from "../schedule/Schedule";
import Archive from "../archive/Archive";

import {connect} from "react-redux";
import {getLiveStreaming} from "../../redux/actions/live-streaming/index";
import {getScheduleInfo} from "../../redux/actions/schedule/index";
import {getProgramInfo} from "../../redux/actions/program/index";
import VideoPlayer from "../player/VideoPlayer";

class Home extends Component {
    constructor(props) {
        super(props);
    }

    async componentDidMount() {
        await this.props.dispatch(getLiveStreaming());
        await this.props.dispatch(getScheduleInfo());
        await this.props.dispatch(getProgramInfo());
    };

    render() {
        const schedule_info = this.props.schedule_info.data;
        const program_info = this.props.program_info.data;
        const live_stream = this.props.live_streaming.data;
        return (
            <div className="App">


                <Banner/>
                {/*{
                    live_stream&&
                    <VideoPlayer
                        poster={live_stream.img_app}
                        src={live_stream.streaming_url}/>

                }*/}
                {
                    schedule_info &&
                    <Schedule scheduleInfo={schedule_info} secTitle="Program Schedule"/>
                }
                {
                    program_info &&
                    <Archive programInfo={program_info}/>
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    live_streaming: state.live_streaming,
    program_info: state.program_info,
    schedule_info: state.schedule_info
});

export default connect(mapStateToProps)(Home);